import * as yup from 'yup';

export const LcCancerDeMamaSchema = yup.object().shape({
  num_registro_mama: yup
    .number()
    .typeError('Campo obrigatório. Máximo 5 dígitos.')
    .required('Campo obrigatório'),
  dn_mama: yup.string().nullable(true),
  convenio_mama: yup.string().nullable(true),
  peso_mama: yup.string().nullable(true),
  altura_mama: yup.string().nullable(true),
  // imc_mama: yup.string().nullable(true),
  avc_mama: yup.string().nullable(true),
  iam_mama: yup.string().nullable(true),
  dm_mama: yup.string().nullable(true),
  autoimune_mama: yup.string().nullable(true),
  tabagismo_mama: yup.string().nullable(true),
  metastase_mama: yup.string().nullable(true),
  ca_inflamatorio_mama: yup.string().nullable(true),
  biopsia_mama: yup.string().nullable(true),
  focos_biopsia_mama: yup.string().nullable(true),
  margens_bipsia_mama: yup.string().nullable(true),
  invasao_linfo_biopsia_mama: yup.string().nullable(true),
  expressao_biopsia_mama: yup.string().nullable(true),

  // Dados da Doença

  estad_clinico_mama: yup.string().nullable(true),

  // Dados da doença e tratamento

  entrada_data_mama: yup.string().nullable(true),
  entrada_hora_mama: yup.string().nullable(true),

  // Tratamento

  cirurgia_data_mama: yup.string().nullable(true),
  cirurgia_tipo_mama: yup.string().nullable(true),
  sentinela_mama: yup.string().nullable(true),
  reconstrucao_mama: yup.string().nullable(true),
  nao_realizacao_mama: yup.string().nullable(true),

  // Laudo anatomopatológico da cirurgia

  focos_cirurgia_mama: yup.string().nullable(true),
  linfonodos_cirurgia_mama: yup.string().nullable(true),
  grau_tumor_mama: yup.string().nullable(true),
  margens_cirurgia_mama: yup.string().nullable(true),
  invasao_linfo_cirurgia_mama: yup.string().nullable(true),
  expressao_cirurgia_mama: yup.string().nullable(true),
  tnm_pos_mama: yup.string().nullable(true),

  // Dados da saída

  covid_mama: yup.string().nullable(true),
  saida_motivo_mama: yup.string().nullable(true),
  saida_data_mama: yup.string().nullable(true),
  saida_hora_mama: yup.string().nullable(true),
});
